import {
  RESET_DUPLICATE_TRANSACTION,
  RESET_TRANSFER_ERROR,
  SET_FNZ_TIMEOUT,
  SET_RESOURCE,
  SET_TRANSACTION_TIMEOUT,
  SET_TRANSFER,
  SET_TRANSFER_DUPLICATED,
  SET_TRANSFER_FAILED,
  SET_TRANSFER_SUCCESS,
} from "./constant";

export function setTransfer(payload, callback) {
  return {
    type: SET_TRANSFER,
    payload,
    callback,
  };
}

export function setTransferSuccess(data) {
  return {
    type: SET_TRANSFER_SUCCESS,
    payload: data,
  };
}

export function setTransferDuplicated() {
  return {
    type: SET_TRANSFER_DUPLICATED,
  };
}

export function setTransactionTimeout() {
  return {
    type: SET_TRANSACTION_TIMEOUT,
  };
}

export const setFnzTimeout = () => ({
  type: SET_FNZ_TIMEOUT,
});

export function resetDuplicateTransaction() {
  return {
    type: RESET_DUPLICATE_TRANSACTION,
  };
}

export function setTransferFailed(error) {
  return {
    type: SET_TRANSFER_FAILED,
    payload: error,
  };
}

export function resetTransferError() {
  return {
    type: RESET_TRANSFER_ERROR,
  };
}

export function setResource(data) {
  return {
    type: SET_RESOURCE,
    payload: data,
  };
}
